import BaseModelInstance from './base.model'
import { SubsiteLink as ModelDefinition } from './model-definitions'

class SubsiteLink extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default SubsiteLink
